import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const ProjectLayout = lazy(() => import('.'))

class ProjectLayoutComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['active-item', 'sticky']
	}

	override render() {
		const activeItem = this.prop('active-item')
		const sticky = this.prop('sticky') === 'true'

		return (
			<RootProviders>
				<ProjectLayout activeItem={activeItem} sticky={sticky} />
			</RootProviders>
		)
	}
}

customElements.define('project-layout', ProjectLayoutComponent)
